<template>
  <div class="centerBox">
    <!-- 筛选框 -->
    <div class="InsuranceSelect">
      <el-row>
        <el-col :span="4" :offset="0">
          <el-select
            v-model="orderStatus"
            placeholder="请选择订单状态"
            size="medium"
            clearable
            @change="selInLists"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="14" :offset="1">
          <el-date-picker
            value-format="yyyy-MM-dd"
            class="timeSection"
            v-model="valueTime"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="changeTimeOrderlist"
          >
          </el-date-picker>
        </el-col>

        <el-col :span="2" :offset="3">
          <el-button
            type="primary"
            size="small"
            @click="buyInsure"
            class="button14"
            >立即投保</el-button
          >
        </el-col>
      </el-row>
      <!-- 分割线 -->
      <el-divider></el-divider>
    </div>

    <!-- 表格 列表组件      有操作按钮 -->
    <table-order-list
      class="tablelist"
      :isShow="isShow"
      @alginGet="alginGet"
      ref="tabList"
      :list="list"
      :loading="loading"
    />

    <pagiation
      :total="total"
      :pageSize="pageSize"
      :pageNo="pageNo"
      @currentChange="currentChange"
      :pagisShow="isShow"
      v-if="isShow"
    />

    <!-- 浮窗 -->
    <fu-box />
  </div>
</template>

<script>
import Pagiation from "@/components/Pagiation.vue";
import FuBox from "../compoments/FuBox.vue";
import TableOrderList from "./TableOrderList.vue";
import sameIn from "@/mixins/listsdetails.js";
import { SessionStorage } from "@/utils/storage";
import { getOrderlist } from "@/api/request/snkd.produce";

export default {
  components: { TableOrderList, FuBox, Pagiation },
  name: "OrderList",
  mixins: [sameIn],

  data() {
    return {
      // 搜索是否有数据  分页是否显示 --  true 显示列表 false显示无数据
      isShow: true,
      loading: true,
      // 订单状态
      options: [
        { value: "10", label: "未支付" },
        {
          value: "20",
          label: "已支付",
        },
        {
          value: "30",
          label: "已关闭",
        },
        {
          value: "40",
          label: "出单中",
        },
      ],
      // 订单状态： 10待付款、 20已付款、 30、已取消',
      orderStatus: SessionStorage.get("seleorderStatus") || "",

      // 时间字段  ===》  处理格式
      valueTime: SessionStorage.get("seleTime") || [],
      // 一段时间
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      // 列表数据
      list: [],
    };
  },
  watch: {
    orderStatus(val) {
      SessionStorage.set("seleorderStatus", val);
    },
  },
  created() {
    this.insureInfo = SessionStorage.get("insureInfo");
    this.getInLists();
  },
  methods: {
    // 筛选
    selInLists() {
      this.pageNo = 1;
      this.getInLists();
    },
    // 获取订单列表
    async getInLists() {
      this.loading = true;
      const { respCode, obj } = await getOrderlist({
        insureId: this.insureInfo.id,
        companyId: this.companyId,
        farmId: this.farmId,
        orderStatus: this.orderStatus,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        startOrderTimeStr: this.valueTime ? this.valueTime[0] : "",
        endOrderTimeStr: this.valueTime ? this.valueTime[1] : "",
      });
      if (respCode === 0) {
        obj.list.forEach((i) => {
          i.btnStatus = false;
        });
        this.list = obj.list;
        this.total = obj.totalCount;
        if (this.list.length) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      }
      this.loading = false;
    },

    // 时间选择器
    changeTimeOrderlist() {
      this.pageNo = 1;
      if (this.valueTime === null) {
        SessionStorage.remove("seleTime");
        this.valueTime = [];
        this.getInLists();
      } else {
        SessionStorage.set("seleTime", this.valueTime);
      }
      this.getInLists();
    },
  },
};
</script>

<style lang="scss" scoped>
.centerBox {
  background-color: #fff;
  .tablelist {
    padding: 0 30px 30px 30px;
    min-height: calc(100vh - 360px);
    overflow: hidden;
  }
}

::v-deep .el-table {
  height: 100%;

  .el-table__body-wrapper {
    overflow: hidden;
    position: relative;
    height: calc(100% - 80px);
  }
}

.InsuranceSelect {
  padding: 30px 30px 0;
}
.el-button {
  width: 92px;
  height: 40px;
}

.timeSection {
  width: 390px;
}
.el-select {
  height: 40px;
}
::v-deep .el-input--medium .el-input__inner {
  height: 40px;
}
</style>
